<template>
  <Drawer
    placement="left"
    :closable="false"
    v-model="openPoint"
    width="280"
    draggable
    class="my-drawer"
    title="路线规划"
  >
    <div id="pointList">
      <Input
        v-model="keyword"
        search
        placeholder="请输入关键字"
        @on-search="getList"
      ></Input>

      <ul>
        <li
          @click="clickItem(item)"
          v-for="(item, index) in tableData"
          :key="index"
          :class="{ active: item.select }"
        >
          {{ item.name }}
        </li>
      </ul>
      <Button
        long
        @click="checkAll"
        :disabled="selectData.length == 0"
        type="primary"
        >取消选择</Button
      >
    </div>
  </Drawer>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openPoint: false,
      tableData: [],
      selectData: [],
      isAll: false,
      keyword: "",
      isLoad: false, //是否已经请求过列表
    };
  },
  methods: {
    open() {
      this.openPoint = true;
      if (!this.isLoad) {
        this.getList();
      }
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/route/list",
        data: { keyword: this.keyword },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (const i in data) {
          data[i].select = false;
          data[i].hasItem = false;
        }
        //var data = [{ name: "11111" }];
        this.tableData = data;
        this.isLoad = true;
      });
    },
    getItem(row) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: this.axios.rule + "/route/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data.coordList;
          
          row.coordList = data;
          this.$emit("lines", this.selectData);
        }
      });
    },
    push() {
      this.selectData = [];
      for (const i in this.tableData) {
        if (this.tableData[i].select) {
          this.selectData.push(this.tableData[i]);
          //如果还没详情
          if (!this.tableData[i].hasItem) {
            this.getItem(this.tableData[i]);
            this.tableData[i].hasItem = true;
          }
        }
      }

      this.$emit("lines", this.selectData);
    },
    clickItem(v) {
      v.select = !v.select;
      this.push();
    },
    checkAll() {
      for (const i in this.tableData) {
        this.tableData[i].select = false;
      }
      this.selectData = [];
      this.$emit("lines", this.selectData);
    },
  },
  mounted() {},
};
</script>
<style lang="">
#pointList {
  height: 100%;
}
#pointList ul {
  height: calc(100% - 80px);
  margin: 10px auto;
  overflow: auto;
}
#pointList li {
  padding: 10px;
  cursor: pointer;
}
#pointList li.active {
  background: #d9ebfe;
}
</style>


// WEBPACK FOOTER //
// src/components/common/lineList.vue